import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Sm10050View from "../../Views/Sales/SM10050";
import Snackbar from "../../Components/Snackbar";
import BasicModal from "../../Components/Modal_Basic";
import Checking from "../../Components/Checking";
import { faL } from "@fortawesome/free-solid-svg-icons";

function SM10050(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [custData, setCustData] = React.useState([]);
  const [inputs, setInputs] = React.useState({
    plantCd: "",
    custNm: "",
    delivOrderDt: "",
    delivOrderNo: "",
    delivQty: "",
    itemNm: "",
    soNo: "",
    delivAmt: "",
    itemCd: "",
    custCd: "",
    filePath: "",
    remark: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [stockData, setStockData] = React.useState([]);
  const [selectedModalData, setSelectedModalData] = React.useState(null);
  const [checkItemCdToggle, setCheckItemCdTolle] = React.useState(false);
  const [modalToggle, setModalToggle] = React.useState(false);
  const [checkInputs, setCheckInputs] = React.useState({
    value1: "",
  });
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [orderNumber, setOrderNumber] = React.useState("");
  const [endDate, setEndDate] = React.useState(new Date());

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  //조회
  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.GetCustMst
      )
        .then((result) => {
          setCustData(result);
        })
        .catch((error) => {
          console.log(error);
        });

      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10050.GetDelivOrders,
        {
          startDate: new Date(startDate),
          endDate: endDate,
          data: orderNumber ? orderNumber : "string",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          if (getLanData.length != 0) {
            setRowData([]);
            setSnackbars({
              toggle: true,
              type: "info",
              message: getLanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else if (data.type === "Error") {
          if (getLanData.length != 0) {
            setRowData([]);
            setSnackbars({
              toggle: true,
              type: "info",
              message: getLanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              stusCd: data[i].stusCd,
              itemCd: data[i].itemCd,
              custCd: data[i].custCd,
              delivOrderNo: data[i].delivOrderNo,
              delivNo: data[i].delivNo,
              custNm: data[i].custNm,
              delivOrderDt: data[i].delivOrderDt
                ? Commons.DateFormating(data[i].delivOrderDt.toString(), 2)
                : "",
              soNo: data[i].soNo,
              delivDt: data[i].delivDt
                ? Commons.DateFormating(data[i].delivDt.toString(), 2)
                : "",
              itemNm: data[i].itemNm,
              delivUser: data[i].delivUser,
              delivOrderUser: data[i].delivOrderUser,
              delivCheckUser: data[i].delivCheckUser,
              delivQty: data[i].delivQty,
              itemUnit: data[i].itemUnit,
              remark: data[i].remark,
              itemStdAmt: data[i].itemStdAmt,
              itemVatYn: data[i].itemVatYn,
              lotNo: data[i].lotNo,
              itemVat:
                data[i].itemVatYn === "Y"
                  ? data[i].delivQty * data[i].itemStdAmt * 0.1
                  : 0,
              itemCost: data[i].delivQty * data[i].itemStdAmt,
              soDueDt: data[i].soDueDt
                ? Commons.DateFormating(data[i].soDueDt.toString(), 2)
                : "",
            });
          }

          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const CreateDelivStatusfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delivery" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delivery" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        CreateDelivStatus();
      }
    );
  };
  const CreateDelivStatus = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let postData = [];
    let userInfo = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      if (!selectedRowData || selectedRowData == null) {
        //선택된 데이터가 없으면
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) => f.lanId === "Snack_SelectData" && f.lanType === "SNACK"
          )[0].lanName, //데이터를 선택해주세요.
        });
      } else {
        await IndexedDb.GetLoginInfo().then((result) => {
          userInfo = result;
        });
        await Commons.Axios(
          "post",
          Global.serverUrls.useUrl +
            Global.urls.logic.Sales.SM10051.CreateDelivStatus,
          {
            plantCd: selectedRowData[0].plantCd,
            delivOrderNo: selectedRowData[0].delivOrderNo,
            delivNo: selectedRowData[0].delivNo,
            soNo: selectedRowData[0].soNo,
            itemCd: selectedRowData[0].itemCd,
            delivDt: selectedRowData[0].delivDt,
            createId: userInfo.userId,
            createDate: Commons.DateStrChange(new Date()),
            updateId: userInfo.userId,
            updateDate: Commons.DateStrChange(new Date()),
          }
        ).then((result) => {
          let data = result.data;

          if (data === "데이터가 없습니다.") {
            setRowData([]);
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          } else if (data.type === "Error") {
            setRowData([]);
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          } else {
            Init();

            setSnackbars({
              toggle: true,
              type: "success",
              message: "납품 되었습니다.",
            });
          }
        });
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //상세보기 조회
  const GetPrintStockData = async (_value, _whCd) => {
    Dialog.ProgressBar(true);
    let getData = [];
    let stockData = [];
    let userInfo;
    try {
      if (selectedRowData.length == 0) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "상세보기 할 데이터를 선택하세요.",
        });
        return false;
      }
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10050.GetPrintStockData,
        {
          delivNo: selectedRowData[0].delivNo,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
          setStockData([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              lotNo: data[i].lotNo,
              itemNm: data[i].itemCd,
              stockQty: data[i].stockQty,
              whNm: data[i].whNm,
            });
          }
          setStockData(getData);
        }
      });
    } catch (e) {
      console.log(e);
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //인쇄
  const Print = async () => {
    let headerData = [];
    let tableData = [];
    let address;
    let purchaseDtlData = [];
    let totalAmt = [];
    let sumAmt = 0;
    let getData = [];
    address =
      "https://dongsungprintingmes.com:8082/SalesManagement/SalesManagement"; //http://localhost:65061/ 114.206.84.134:5540 https://dongsungprintingmes.com:8082

    if (selectedRowData.length === 0) {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
        )[0].lanName,
      });
    } else {
      for (let i = 0; i < selectedRowData.length; i++) {
        for (let j = i + 1; j < selectedRowData.length; j++) {
          if (selectedRowData[i].custNm != selectedRowData[j].custNm) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: "항목중에 다른 거래처가 있습니다.",
            }); // 중복된 항목 발견
            return false;
          }
        }
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetPrintData,
        {
          delivOrderNo: selectedRowData[0].delivOrderNo,
          delivOrderDt: selectedRowData[0].delivOrderDt,
        }
      ).then((result) => {
        let data = result.data;
        let getData = [];
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < selectedRowData.length; j++) {
            if (data[i].delivNo == selectedRowData[j].delivNo) {
              getData.push(data[i]);
            }
          }
        }
        if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < getData.length; i++) {
            tableData.push({
              DelivDt: getData[i].delivDt
                ? Commons.DateFormating(getData[i].delivDt.toString(), 2)
                : "",
              ItemNm: getData[i].itemNm,
              DelivQty: getData[i].delivQty,
              ItemStdAmt: getData[i].itemStdAmt,
              ItemCost: getData[i].delivQty * getData[i].itemStdAmt,
              ItemVat:
                getData[i].itemVatYn === "Y"
                  ? getData[i].delivQty * getData[i].itemStdAmt * 0.1
                  : 0,
            });
            totalAmt.push(
              getData[i].delivQty * getData[i].itemStdAmt +
                (getData[i].itemVatYn === "Y"
                  ? getData[i].delivQty * getData[i].itemStdAmt * 0.1
                  : 0)
            );
          }
          for (let i = 0; i < totalAmt.length; i++) {
            sumAmt += totalAmt[i];
          }

          headerData.push({
            ReportTitle: "거래명세서",
            CustNm: getData[0].custNm,
            SerialNo: selectedRowData[0].delivDt
              ? Commons.DateFormating(selectedRowData[0].delivDt.toString(), 4)
              : "",
            TotalAmt: sumAmt,
            TotalAmtKr: convertToKoreanNumber(sumAmt),
            CustTel: getData[0].custTel,
            BusinessNo: getData[0].businessNo,
            PersonCharg: getData[0].personCharg,
            CustShortNm: getData[0].custShortNm,
            Address: getData[0].address,
          });
          var f = document.createElement("form");
          f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
          f.method = "POST";
          f.target = "_blank";

          var k = document.createElement("input");
          k.type = "hidden";
          k.name = "headerData";
          k.value = JSON.stringify(headerData);
          f.append(k);
          var l = document.createElement("input");
          l.type = "hidden";
          l.name = "tableData";
          l.value = JSON.stringify(tableData);
          f.append(l);
          document.body.appendChild(f);

          f.submit();
        }
      });
    }
  };
  //인쇄1
  const Print1 = async () => {
    let headerData = [];
    let tableData = [];
    let address;
    let purchaseDtlData = [];
    let totalAmt = [];
    let sumAmt = 0;
    let getData = [];
    //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);

    //address = "http://localhost:65061/SalesManagement/SalesManagementRemark"; //http://localhost:65061/ 114.206.84.134:5540
    address =
      "https://dongsungprintingmes.com:8082/SalesManagement/SalesManagementRemark"; //http://localhost:65061/ 114.206.84.134:5540 https://dongsungprintingmes.com:8082

    if (selectedRowData.length === 0) {
      setSnackbars({
        toggle: true,
        type: "info",
        message: lanData.filter(
          (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
        )[0].lanName,
      });
    } else {
      for (let i = 0; i < selectedRowData.length; i++) {
        for (let j = i + 1; j < selectedRowData.length; j++) {
          if (selectedRowData[i].custNm != selectedRowData[j].custNm) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: "항목중에 다른 거래처가 있습니다.",
            }); // 중복된 항목 발견
            return false;
          }
        }
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.GetPrintData,
        {
          delivOrderNo: selectedRowData[0].delivOrderNo,
          delivOrderDt: selectedRowData[0].delivOrderDt,
        }
      ).then((result) => {
        let data = result.data;
        let getData = [];
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < selectedRowData.length; j++) {
            if (data[i].delivNo == selectedRowData[j].delivNo) {
              getData.push(data[i]);
            }
          }
        }
        if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < getData.length; i++) {
            tableData.push({
              DelivDt: getData[i].delivDt
                ? Commons.DateFormating(getData[i].delivDt.toString(), 2)
                : "",
              ItemNm: getData[i].itemNm,
              DelivQty: getData[i].delivQty,
              ItemStdAmt: getData[i].itemStdAmt,
              ItemCost: getData[i].delivQty * getData[i].itemStdAmt,
              ItemVat:
                getData[i].itemVatYn === "Y"
                  ? getData[i].delivQty * getData[i].itemStdAmt * 0.1
                  : 0,
            });
            totalAmt.push(
              getData[i].delivQty * getData[i].itemStdAmt +
                (getData[i].itemVatYn === "Y"
                  ? getData[i].delivQty * getData[i].itemStdAmt * 0.1
                  : 0)
            );
          }
          for (let i = 0; i < totalAmt.length; i++) {
            sumAmt += totalAmt[i];
          }

          headerData.push({
            ReportTitle: "거래명세서",
            CustNm: getData[0].custNm,
            SerialNo: selectedRowData[0].delivDt
              ? Commons.DateFormating(selectedRowData[0].delivDt.toString(), 4)
              : "",
            TotalAmt: sumAmt,
            TotalAmtKr: convertToKoreanNumber(sumAmt),
            CustTel: getData[0].custTel,
            BusinessNo: getData[0].businessNo,
            PersonCharg: getData[0].personCharg,
            CustShortNm: getData[0].custShortNm,
            Address: getData[0].address,
          });
          var f = document.createElement("form");
          f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
          f.method = "POST";
          f.target = "_blank";

          var k = document.createElement("input");
          k.type = "hidden";
          k.name = "headerData";
          k.value = JSON.stringify(headerData);
          f.append(k);
          var l = document.createElement("input");
          l.type = "hidden";
          l.name = "tableData";
          l.value = JSON.stringify(tableData);
          f.append(l);
          document.body.appendChild(f);

          f.submit();
        }
      });
    }
  };
  // 금액(한글) 변환
  function convertToKoreanNumber(num) {
    var numKor = new Array(
      "",
      "일",
      "이",
      "삼",
      "사",
      "오",
      "육",
      "칠",
      "팔",
      "구",
      "십"
    ); // 숫자 문자
    var numKor2 = new Array(
      "영",
      "일",
      "이",
      "삼",
      "사",
      "오",
      "육",
      "칠",
      "팔",
      "구",
      "십"
    ); // 소수점 이하 문자
    var danKor = new Array(
      "",
      "십",
      "백",
      "천",
      "",
      "십",
      "백",
      "천",
      "",
      "십",
      "백",
      "천",
      "",
      "십",
      "백",
      "천"
    ); // 만위 문자열
    var result = ""; // 숫자 결과
    var result2 = ""; // 소수점 결과

    if (num && !isNaN(num)) {
      // CASE: 금액이 공란/NULL/문자가 포함된 경우가 아닌 경우에만 처리
      var val = num.toString();
      var val2 = "";
      if (val.indexOf(".")) {
        // 소수점이 있을 경우, 소수점 뒷 부분은 따로 + result
        val2 = val.split(".")[1] == undefined ? "" : val.split(".")[1];
        val = val.split(".")[0];
      }

      for (var i = 0; i < val.length; i++) {
        var str = "";
        var num = numKor[val.charAt(val.length - (i + 1))];
        if (num != "") str += num + danKor[i]; // 숫자가 0인 경우 텍스트를 표현하지 않음
        switch (i) {
          case 4:
            str += "만";
            break; // 4자리인 경우 '만'을 붙여줌 ex) 10000 -> 일만
          case 8:
            str += "억";
            break; // 8자리인 경우 '억'을 붙여줌 ex) 100000000 -> 일억
          case 12:
            str += "조";
            break; // 12자리인 경우 '조'를 붙여줌 ex) 1000000000000 -> 일조
        }

        result = str + result;
      }

      // Step. 불필요 단위 제거
      if (result.indexOf("억만") > 0) result = result.replace("억만", "억");
      if (result.indexOf("조만") > 0) result = result.replace("조만", "조");
      if (result.indexOf("조억") > 0) result = result.replace("조억", "조");

      // 소수점 이하가 있을경우
      if (val2 != "") {
        result = result + "점";

        // 소수점 변환
        for (var j = 0; j < val2.length; j++) {
          var num2 = numKor2[val2.charAt(val2.length - (j + 1))];

          result2 = num2 + result2;
        }
      }

      result = result + result2 + "원 정";
    }

    return result;
  }
  return (
    <>
      <Sm10050View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        setInputs={setInputs}
        GetPrintStockData={GetPrintStockData}
        inputs={inputs}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        orderNumber={orderNumber}
        setOrderNumber={setOrderNumber}
        Init={Init}
        CreateDelivStatusfirm={CreateDelivStatusfirm}
        stockData={stockData}
        setStockData={setStockData}
        selectedModalData={selectedModalData}
        setSelectedModalData={setSelectedModalData}
        Print={Print}
        Print1={Print1}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}{" "}
    </>
  );
}

export default SM10050;
